import { LocalStorage } from 'ttl-localstorage'
export default class TtlLocalStorage {
    constructor(config) {
        this.config = Object.assign({
            timestamp: config.timestamp,
            namespace: config.namespace,
        }, config)

        this.prefix = `${this.config.namespace || ''}_`
    }

    async get (key) {
        return await LocalStorage.get(`${this.prefix}${key}`)
    }

    async set (key, data, config = {}) {
        if (!key || !data) {
            console.warn('key & data is required')
            return
        }
        let { timestamp = 0 } = config
        timestamp = timestamp || this.config.timestamp
        key = `${this.prefix}${key}`
        const args = [key, data, timestamp].filter(v => v)
        return await LocalStorage.put(...args)
    }

    async keys () {
        const reg = `^${this.prefix}.*`
        let keys = await LocalStorage.keys()

        if (keys && keys.length) {
            keys = keys.filter(v => v.includes(this.prefix) && v.match(reg)).map(v => v.replace(this.prefix, ''))
            return keys
        }
        return []
    }

    async clear () {
        const reg = `^${this.prefix}.*`
        let keys = await LocalStorage.keys()

        if (keys && keys.length) {
            keys = keys.filter(v => v.includes(this.prefix) && v.match(reg)).map(v => LocalStorage.removeKey.bind(LocalStorage, v))
            return Promise.all(keys.map(v => v()))
        }

        return Promise.resolve()
    }

    async removeKey (key) {
        return await LocalStorage.removeKey(`${this.prefix}${key}`)
    }

}
